import React from "react";

export default function ObisLayerDescription({layer}) {
    const taxonDescription = <span><strong>{layer.taxon.scientificName}</strong></span>;
    let periodDescription = null;
    if (layer.startYear || layer.endYear) {
        periodDescription = <span> for period <strong>{ layer.startYear } - { layer.endYear }</strong></span>;
    }
    return <p>Occurrences of { taxonDescription } { periodDescription }</p>;
}